import { useFeatureValue } from '@growthbook/growthbook-react';
import { dealPromptFlags } from '@openx/constants/feature-flag-keys.ts';
import type { DealPromptFeatureFlaggedFilters } from '@openx/types/dealPrompt.ts';
import {
  BUNDLES_DEFAULT_NUMBER_OF_RESULTS,
  DEFAULT_BUNDLES_CPR_MARKET_REQUESTS_THRESHOLD,
  DEFAULT_BUNDLES_IMPRESSIONS_THRESHOLD,
  DEFAULT_DOMAINS_CPR_MARKET_REQUESTS_THRESHOLD,
  DEFAULT_DOMAINS_IMPRESSIONS_THRESHOLD,
  DEFAULT_MARKET_THRESHOLD,
  DOMAINS_DEFAULT_NUMBER_OF_RESULTS,
} from '../utils/filters/defaultFilters.ts';

export const useDealPromptFeatureFlaggedFilters = (): DealPromptFeatureFlaggedFilters => {
  const domainsNumberOfResults = useFeatureValue(
    dealPromptFlags.DEAL_PROMPT_DOMAINS_NUMBER_OF_RESULTS,
    DOMAINS_DEFAULT_NUMBER_OF_RESULTS
  );
  const bundlesNumberOfResults = useFeatureValue(
    dealPromptFlags.DEAL_PROMPT_BUNDLES_NUMBER_OF_RESULTS,
    BUNDLES_DEFAULT_NUMBER_OF_RESULTS
  );
  const marketThreshold = useFeatureValue(dealPromptFlags.DEAL_PROMPT_MARKET_THRESHOLD, DEFAULT_MARKET_THRESHOLD);
  const domainsImpressionsThreshold = useFeatureValue(
    dealPromptFlags.DEAL_PROMPT_DOMAINS_IMPRESSIONS_THRESHOLD,
    DEFAULT_DOMAINS_IMPRESSIONS_THRESHOLD
  );
  const bundlesImpressionsThreshold = useFeatureValue(
    dealPromptFlags.DEAL_PROMPT_BUNDLES_IMPRESSIONS_THRESHOLD,
    DEFAULT_BUNDLES_IMPRESSIONS_THRESHOLD
  );
  const domainsCprMarketRequestsThreshold = useFeatureValue(
    dealPromptFlags.DEAL_PROMPT_DOMAINS_CPR_MARKET_REQUESTS_THRESHOLD,
    DEFAULT_DOMAINS_CPR_MARKET_REQUESTS_THRESHOLD
  );
  const bundlesCprMarketRequestsThreshold = useFeatureValue(
    dealPromptFlags.DEAL_PROMPT_BUNDLES_CPR_MARKET_REQUESTS_THRESHOLD,
    DEFAULT_BUNDLES_CPR_MARKET_REQUESTS_THRESHOLD
  );

  return {
    domainsNumberOfResults,
    bundlesNumberOfResults,
    marketThreshold,
    domainsImpressionsThreshold,
    bundlesImpressionsThreshold,
    domainsCprMarketRequestsThreshold,
    bundlesCprMarketRequestsThreshold,
  };
};
